import { PropsWithChildren } from 'react';

import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import { ToolbarItem as ToolbarItemStyled } from './toolbar.style';

type Props = PropsWithChildren<{ hoverText: string }>;

const ToolbarItem = ({ children, hoverText }: Props) => {
  return (
    <ToolbarItemStyled>
      <TooltipWrapper hoverText={hoverText}>{children}</TooltipWrapper>
    </ToolbarItemStyled>
  );
};

export default ToolbarItem;
